import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class OwnerInfoNews extends AManagerApi {
    protected _url: string = '/owner/info/news';
}
